import { z } from 'zod';
/**
 * Cabecera con los segundos que la persona lleva sin usar la pantalla (teclado, ratón, toque). La web la manda en
 * cada petición: las consultas automáticas de una ventana olvidada informan que nadie la usa y la sesión vence.
 */
export const IDLE_HEADER = 'x-idle-seconds';
/**
 * Por qué el API dice que la sesión ya no sirve (401). `REPLACED`: la persona siguió en otra sesión (la eligió, o esta
 * dejó de responder mientras se decidía); `CONFLICT_TIMEOUT`: nadie eligió a tiempo y la política la cerró;
 * `SUITE_LOGOUT`: la persona cerró sesión en la suite o en otra de sus apps (back-channel logout, GUIA §3.1).
 */
export const SESSION_END_CODES = {
    IDLE: 'SESSION_IDLE',
    EXPIRED: 'SESSION_EXPIRED',
    REVOKED: 'SESSION_REVOKED',
    REPLACED: 'SESSION_REPLACED',
    CONFLICT_TIMEOUT: 'SESSION_CONFLICT_TIMEOUT',
    SUITE_LOGOUT: 'SESSION_SUITE_LOGOUT',
};
/**
 * Sesiones simultáneas. Un ingreso con otra sesión abierta de la misma persona (una pestaña viva en otro equipo o
 * navegador) deja a todas en espera: el API responde 409 `SESSION_CONFLICT` a todo menos `GET /auth/session`,
 * `POST /auth/session/resolve`, `GET /auth/me` y salir, hasta que la persona elija en cuál seguir desde cualquiera.
 */
export const SESSION_CONFLICT = 'SESSION_CONFLICT';
/**
 * Qué pasa si nadie elige a tiempo (`AUTH_SESSION_CONFLICT_SECONDS`): `CLOSE_ALL` cierra todas (la persona vuelve a
 * ingresar donde esté; por defecto) y `KEEP_NEWEST` deja solo la del ingreso más reciente.
 */
export const SESSION_CONFLICT_POLICIES = ['CLOSE_ALL', 'KEEP_NEWEST'];
export const resolveSessionConflictSchema = z.object({ keep: z.enum(['THIS', 'OTHER']) });
//# sourceMappingURL=session.js.map